module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "x9781590207048-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Opening-Para",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_vm._v("In the beginning was Chance, and Chance was with God and Chance was God. He was in the beginning with God. All things were made by Chance and without him not anything made that was made. In Chance was life and the life was the light of men.")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_vm._v("There was a man sent by Chance, whose name was Luke. The same came for a witness, to bear witness of Whim, that all men through him might believe. He was not Chance, but was sent to bear witness of Chance. That was the true Accident, that randomizes every man that cometh into the world. He was in the world and the world was made by him, and the world knew him not. He came unto his own, and his own received him not. But as many as received him, to them gave he power to become the sons of Chance, even to them that believe accidentally, they which were born, not of blood, nor of the will of the flesh, nor of the will of man, but of Chance. And Chance was made flesh (and we beheld his glory, the glory as of the only begotten of the Great Fickle Father), and he dwelt among us, full of chaos and falsehood and whim.")]), _vm._v(" "), _c('p', {
    staticClass: "Author"
  }, [_vm._v("—from "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("The Book of the Die")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c9356d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781590207048-4.vue
// module id = 72
// module chunks = 0